var _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeedHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "90px",
    height: "90px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(0, 0, 0)",
    d: "M43.423,16.155 C27.469,16.155 14.458,28.853 14.000,44.759 L14.000,73.036 C14.000,74.149 14.850,74.999 15.962,74.999 L15.962,74.999 L43.685,74.999 C60.227,74.869 73.500,61.123 72.846,44.366 C72.192,29.180 59.900,16.875 44.796,16.155 C44.339,16.155 43.881,16.155 43.423,16.155 L43.423,16.155 Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Didot",
    fill: "rgb(255, 255, 255)",
    transform: "matrix( 1.84833342236771, 0, 0, 1.84833342236771,35.953228827223, 64.4075009348609)",
    fontSize: "30px"
  }, "i")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedHelpIcon);
export default __webpack_public_path__ + "static/media/needHelpIcon.fa00bc291295a76d43f46b21454a143c.svg";
export { ForwardRef as ReactComponent };